/**
 * Cloudflare Turnstile (spam protection) configuration.
 *
 * The site key is public and safe to ship in the browser bundle.
 * Paste your Turnstile site key below (starts with 0x...).
 * Until it is set, forms keep working exactly as before with no widget shown.
 */
export const TURNSTILE_SITE_KEY: string =
  (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) || "";

export const turnstileEnabled = () => TURNSTILE_SITE_KEY.length > 0;
